import styled from 'styled-components';
import LazyLoadImage from '~/components/utilities/lazyload-image';
import { useBannerContext } from '../context/banner-context';
import { IMG_SIZES } from '../config';

const Container = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	pointer-events: none;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
	}
`;

const BackgroundImage: React.FC = () => {
	const {
		data: { backgroundImage, url },
		helpers: { shouldLazyLoad }
	} = useBannerContext();

	return (
		<Container>
			<LazyLoadImage
				src={backgroundImage.src}
				srcSet={backgroundImage.srcSet}
				sizes={IMG_SIZES.background}
				alt={url ?? ''}
				lazyload={shouldLazyLoad}
			/>
		</Container>
	);
};

export default BackgroundImage;
